import React, { useEffect, useState } from "react";
import { Container, Row, Col, TabContent, TabPane } from "reactstrap";
import LoginTab from "./Tabs/LoginTab";
import imgg from "../assets/images/codifyformatter.png";

const Signin = () => {
  useEffect(() => {
    const username = localStorage.getItem("username");
    if (username === null) {
      localStorage.removeItem("authTokens");
    } else {
      localStorage.removeItem("authTokens");
      localStorage.removeItem("username");
    }
  }, []);
  return (
    <Container fluid={true} className="p-0">
      <Row className="mx-0">
        <Col xs="12" className="px-0">
          <div
            className="login-card1"
            style={{
              backgroundImage: `url(${imgg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="login-main1 login-tab1">
              <LoginTab />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Signin;
